import { Message } from "../../../messages/Message";
import { MessageType } from "../../../messages/MessageType";
import { SourceInfo } from "./SourceInfo";


export class ParserMessage extends Message
{
  sourceInfo:SourceInfo;

  static create( type:MessageType, content:string, sourceInfo:SourceInfo )
  { 
    let m = new ParserMessage();
    
    m.type = type;
    m.content = content;
    m.sourceInfo = sourceInfo;

    return m;
  }
}